module.exports = __webpack_public_path__ + "static/media/logo.e6f51088.png";